import { Box, Typography, useMediaQuery, useTheme } from "@mui/material"
import React from "react"
import { Colors } from "../../constants/colors"
import { formatTime } from "../../utils/func"

export interface CustomCallTimerProps {
  duration: number
  maxDuration: number
}

export default function CustomCallTimer({
  duration,
  maxDuration,
}: CustomCallTimerProps) {
  const timeRemaining = Math.max(0, maxDuration - duration)
  const formattedTimeRemaining = formatTime(timeRemaining)
  const isLessThan1Minute = timeRemaining < 60

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const top = `var(--spacing-tokens-size-in-px-spacing-spacing-${isMobile ? "xl" : "5xl"})`
  const right = `var(--spacing-tokens-size-in-px-spacing-spacing-${isMobile ? "xl" : "10xl"})`

  return (
    <Box
      padding={"6px 12px"}
      position="absolute"
      top={top}
      right={right}
      color={Colors.White}
      sx={{
        backgroundColor: isLessThan1Minute
          ? "#C10B1199"
          : "var(--colors-light-background-bg-overlay-2)",
        backdropFilter: "blur(3px)",
        borderRadius: "50px",
        zIndex: 1,
        height: "30px",
      }}
    >
      <Typography color={Colors.White} variant="body2">
        Remaining time: {formattedTimeRemaining}
      </Typography>
    </Box>
  )
}
